import Vue from 'vue'

export const EventBus = new Vue()

export const FILE_UPLOADED = 'FILE_UPLOADED'
export const FILE_RENAMED = 'FILE_RENAMED'
export const FILE_REMOVED = 'FILE_REMOVED'
